export const videoPlayerConfig = {
  videosPerPage: 6,
  animationDuration: 500, // ms
  thumbnailMinWidth: 120, // px
  thumbnailHeight: 100, // px
} as const;

export type VideoPlayerConfig = typeof videoPlayerConfig;
